export const Page = {
  registrationTitle: 'Kiosk check-in'
};

export const APP_ROOT = 'root';

export const CHECKIN_FIELDS = {
  FIRST_NAME: {
    label: 'Given name',
    maxLength: 50
  },
  LAST_NAME: {
    label: 'Family name',
    maxLength: 80
  },
  CONTACT_NUMBER: {
    label: 'Phone number',
    placeholder: 'e.g +61 421 123 456'
  }
};

export const QUERY_KEY = {
  RegisterResponse: 'registerResponse',
  RegisteredLocations: 'registeredLocations'
};

export const CHECKED_IN_MSG = 'Checked-in';
export const CHECKED_IN_MSG_ERROR = 'Something went wrong';

// Clear form and check-in notification delay.
export const CLEAR_CHECKIN_FORM_DELAY = 3000;

/**
 * Maximum time allowed for keeping the user ssession active wihtout any action
 */
export const SESSION_TIMEOUT_THRESHOLD_MILLISECONDS = 300000;

export const GenericValidationErrors = {
  required: 'We can’t help you without this information.',
  invalidSecurityOrKioskCode: 'That doesn’t look like a valid code. Please try again.'
};

export const externalLinks = {
  privacyPolicy: '/check-in-privacy',
  safariBookmarkHelp: 'https://support.apple.com/en-au/guide/safari/ibrw1039/mac',
  firefoxBookmarkHelp:
    'https://support.mozilla.org/en-US/kb/bookmarks-firefox#w_how-do-i-bookmark-a-page',
  ieBookmarkHelp:
    'https://support.microsoft.com/search/results?query=favourites+internet+explorer&isEnrichedQuery=false',
  edgeBookmarkHelp:
    'https://support.microsoft.com/en-us/microsoft-edge/add-a-site-to-my-favorites-in-microsoft-edge-eb40d818-fd1f-cb19-d943-6fcfd1d9a935'
};

export const Routes = {
  About: '/about',
  Root: '/',
  Register: '/register',
  Verify: '/verify',
  RegisteredLocation: '/registered-location',
  RegistrationSuccess: '/register-success',
  CheckIn: '/check-in',
  Others: '*'
};
